module.exports = __webpack_public_path__ + "img/activeresume.db7ae60a.svg";